import React__default from 'react';
import PropTypes from 'prop-types';
import { successGreen, blueGrey, primary, gold } from '../assets/colors.js';
import Badge from './Badge.js';

var typeLabel = {
  MB: "PGA MEMBER",
  ST: "STUDENT",
  AP: "ASSOCIATE",
  PE: "PUBLIC EMPLOYER",
  PQ: "PRE-QUALIFIER",
  QE: "QUALIFIER ELIGIBLE",
  TA: "TERMINATED APPRENTICE",
  FA: "FACILITY",
  AF: "AFFILIATE"
};
var typeBadgeColor = {
  MB: "".concat(gold),
  ST: "".concat(primary),
  AP: "".concat(blueGrey),
  FA: "".concat(successGreen)
};
var isAffiliate = function isAffiliate(memberClass) {
  return memberClass === "AF";
};
var MemberTypeBadge = function MemberTypeBadge(_ref) {
  var type = _ref.type,
    memberClass = _ref.memberClass;
  return /*#__PURE__*/React__default.createElement(Badge, {
    color: typeBadgeColor[type]
  }, isAffiliate(memberClass) ? typeLabel.AF : typeLabel[type]);
};
MemberTypeBadge.displayName = "MemberTypeBadge";
MemberTypeBadge.propTypes = {
  type: PropTypes.oneOf(["MB", "ST", "AP", "PE", "QE", "PQ", "TA", "FA"]).isRequired,
  "class": PropTypes.string
};

export { MemberTypeBadge as default };
